import { useState } from "react";
import { isBlankPhoneInput } from "../phone";
import { api, setToken, type UserOut } from "../api";

export function Login({ onLogin }: { onLogin: (u: UserOut) => void }) {
  const [phone, setPhone] = useState("+998");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (isBlankPhoneInput(phone)) { setErr("Telefon raqamini kiriting"); return; }
    setErr(null); setBusy(true);
    try {
      const r = await api.login(phone, password);
      if (r.user.role !== "platform_owner") {
        setErr("Bu sahifa faqat platforma admini uchun");
        setBusy(false);
        return;
      }
      setToken(r.access_token);
      onLogin(r.user);
    } catch (e) {
      setErr((e as Error).message || "Kirish muvaffaqiyatsiz");
    } finally { setBusy(false); }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <h1>AvtoDaftar</h1>
        <div className="subtitle">Platforma admin paneli</div>
        <div className="row">
          <label>Telefon</label>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+998..." required autoFocus />
        </div>
        <div className="row">
          <label>Parol</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {err && <div className="error">{err}</div>}
        <button type="submit" className="btn" disabled={busy}>{busy ? "..." : "Kirish"}</button>
      </form>
    </div>
  );
}
